export default "__VITE_ASSET__0740f1fb__"